import { Breadcrumb } from 'modules/model-json';
import {
  CABINET_SOLUTION_TAB_LIST,
  CABINET_SOLUTION_CONTENT_MAP,
  HALLWAY_SOLUTION_TAB_LIST,
  HALLWAY_SOLUTION_CONTENT_MAP,
  LIVING_ROOM_SOLUTION_TAB_LIST,
  LIVING_ROOM_SOLUTION_CONTENT_MAP,
  KIDS_SOLUTION_TAB_LIST,
  KIDS_SOLUTION_CONTENT_MAP,
} from './components';

export const SPACEO_KUB_PATH = '/promo/spaceo-kub/';

export const UPDATED_SPACEO_BREADCRUMB: Breadcrumb = {
  label: 'Проектирование систем хранения',
  link: '/uslugi/proektirovanie-i-dizayn/proektirovanie-sistem-hraneniya/',
};

export const SOLUTION_LIST = [
  {
    content: KIDS_SOLUTION_CONTENT_MAP,
    sectionName: 'kidsRoom',
    selectionGroupOptionList: KIDS_SOLUTION_TAB_LIST,
    title: 'Решения для\u00A0детской',
  },
  {
    content: LIVING_ROOM_SOLUTION_CONTENT_MAP,
    reverse: true,
    sectionName: 'livingRoom',
    selectionGroupOptionList: LIVING_ROOM_SOLUTION_TAB_LIST,
    title: 'Решения для\u00A0гостиной',
  },
  {
    content: CABINET_SOLUTION_CONTENT_MAP,
    sectionName: 'cabinet',
    selectionGroupOptionList: CABINET_SOLUTION_TAB_LIST,
    title: 'Решения для\u00A0кабинета',
  },
  {
    content: HALLWAY_SOLUTION_CONTENT_MAP,
    reverse: true,
    sectionName: 'hallway',
    selectionGroupOptionList: HALLWAY_SOLUTION_TAB_LIST,
    title: 'Решения для\u00A0прихожей',
  },
];

export const PRODUCT_ID_LIST = [
  '81990647',
  '81990629',
  '81990631',
  '81990637',
  '81990619',
  '81990611',
  '81990616',
  '81990623',
  '81990633',
  '81990640',
];
